import { call } from 'redux-saga/effects'
import { makeToast } from '../../util/toast_util'

export function* handleAlert(setAlerts) {
    const { alert, vars = []} = setAlerts
    const message = typeof alert.msg === 'function'
        ? alert.msg(vars)
        : alert.msg
    yield call(makeToast, message, alert.class)
}


// WEBPACK FOOTER //
// ./src/redux/sagas/alert_sagas.js